// import React from 'react';
// import { TextField, InputAdornment } from '@mui/material';
// import { useTheme } from '@mui/material/styles';

// /**
//  * A reusable text area component for entering multi-line notes or content.
//  * Supports custom styling via theme, error state, helper text, and optional end icon.
//  */
// const CustomTextArea = ({
//   name,
//   value,
//   onChange,
//   onBlur,
//   error,
//   helperText,
//   placeholder,
//   rows = 4,
//   endIcon,
//   InputProps: inputProps = {},
//   ...rest
// }) => {
//   const theme = useTheme();

//   return (
//     <TextField
//       fullWidth
//       multiline
//       rows={rows}
//       name={name}
//       value={value}
//       onChange={onChange}
//       onBlur={onBlur}
//       error={Boolean(error)}
//       helperText={helperText}
//       placeholder={placeholder}
//       InputProps={{
//         ...inputProps,
//         endAdornment: endIcon ? (
//           <InputAdornment position="end">
//             {endIcon}
//           </InputAdornment>
//         ) : inputProps.endAdornment,
//         sx: {
//           '& .MuiInputBase-input': {
//             padding: '0px 5px',
//           },
//           borderRadius: theme.formFileds.borderRadius,
//           fontSize: '14px',
//           // Merge any additional sx passed in
//           ...inputProps.sx,
//         },
//       }}
//       sx={{
//         // Ensure the TextField container respects theme height if needed
//         // height: `calc(${theme.formFileds.height} * ${rows / 1})`,
//       }}
//       {...rest}
//     />
//   );
// };

// export default CustomTextArea;


// -----------------------------------------------------------------

// import React from 'react';
// import { TextareaAutosize, InputAdornment } from '@mui/material';
// import { useTheme } from '@mui/material/styles';

// /**
//  * A reusable text area component using TextareaAutosize for dynamic height.
//  * Supports custom styling via theme, error state, helper text, and optional end icon.
//  */
// const CustomTextArea = ({
//   name,
//   value,
//   onChange,
//   onBlur,
//   error,
//   helperText,
//   placeholder,
//   minRows = 4,
//   maxRows,
//   endIcon,
//   style = {},
//   ...rest
// }) => {
//   const theme = useTheme();

//   return (
//     <div style={{ position: 'relative', width: '100%' }}>
//       <TextareaAutosize
//         name={name}
//         value={value}
//         onChange={onChange}
//         onBlur={onBlur}
//         placeholder={placeholder}
//         minRows={minRows}
//         maxRows={maxRows}
//         style={{
//           width: '100%',
//           padding: '12px',
//           fontSize: '14px',
//           borderRadius: theme.formFileds.borderRadius,
//         //   border: error ? '1px solid red' : '1px solid #ccc',
//           fontFamily: theme.typography.fontFamily,
//           ...style,
//         }}
//         {...rest}
//       />
//       {helperText && (
//         <div style={{
//           color: error ? theme.palette.error.main : theme.palette.text.secondary,
//           fontSize: '12px',
//           marginTop: '4px'
//         }}>
//           {helperText}
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomTextArea;




import React, { useState } from 'react';
import { TextareaAutosize, InputAdornment } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * A reusable text area component using TextareaAutosize for dynamic height.
 * Supports custom styling via theme, error state, helper text, and optional end icon.
 */
const CustomTextArea = ({
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  placeholder,
  minRows = 4,
  maxRows,
  endIcon,
  style = {},
  ...rest
}) => {
  const theme = useTheme();
  const [isFocused, setIsFocused] = useState(false);

  const getBorderColor = () => {
    if (error) return '#d32f2f';
    if (isFocused) return 'rgba(0, 0, 0, 0.87)';
    return 'rgba(0, 0, 0, 0.38)';
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <TextareaAutosize
        name={name}
        value={value}
        onChange={onChange}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur?.(e);
        }}
        onFocus={() => setIsFocused(true)}
        placeholder={placeholder}
        minRows={minRows}
        maxRows={maxRows}
        style={{
          width: '100%',
          padding: '12px',
          fontSize: '14px',
          borderRadius: theme.formFileds.borderRadius,
          border: `1px solid ${getBorderColor()}`,
          outline: 'none',
          fontFamily: theme.typography.fontFamily,
          transition: 'border-color 0.2s ease-in-out',
          resize: 'none',
          ...style,
        }}
        {...rest}
      />
      {helperText && (
        <div style={{
          color: error ? theme.palette.error.main : theme.palette.text.secondary,
          fontSize: '12px',
          marginTop: '4px'
        }}>
          {helperText}
        </div>
      )}
    </div>
  );
};

export default CustomTextArea;